import { ChatError } from "@/react/components/Modals/MessagingModal/ChatError";
import { ErrorBoundary } from "@/react/components/shared/ErrorPages/ErrorBoundary";
import { DMsListComponent } from "./DMsListComponent";

export const DMsList = () => (
  <ErrorBoundary renderFunc={ChatError}>
    <DMsListComponent />
  </ErrorBoundary>
);
